<!-- 创建时间2024/02/29 11:40:21 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： 微课选择-->
<template>
  <yxt-drawer
      :title='$t("pc_kng_template_btn_choose_micro"/* 选择微课 */)'
      size="960px"
      :visible.sync="visible"
      destroy-on-close
    >
      <yxtbiz-tcm-select
        ref="tcmSelect"
        :hasSelected="selected"
        :chooseLimit="selectableLength"
        :tcmStatus="1"
        @select="onSelect"
      >
      </yxtbiz-tcm-select>
      <div slot='footer'>
        <yxt-button plain @click="cancel">{{ $t('pc_kng_common_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" @click="confirm">{{ $t('pc_kng_common_btn_confirm') }}</yxt-button>
      </div>
    </yxt-drawer>
</template>

<script>
export default {
  name: 'wei-ke-selector',
  inject: ['getSelectableLength'],
  data() {
    return {
      visible: false,
      selected: []
    };
  },
  computed: {
    selectableLength() {
      return this.getSelectableLength();
    }
  },
  methods: {
    init() {
      this.selected = [];
      return new Promise((resolve, reject) => {
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onSelect(val) {
      this.selected = val;
    },
    cancel() {
      this.visible = false;
    },
    confirm() {
      const list = this.$refs.tcmSelect.getSelected(); // 限制条件下的个数
      if (list.length !== this.selected.length) return;
      const data = this.selected.map(item => {
        const { id: wkId, courseName: title, courseSource, courseCover: coverUrl, duration: studyHours } = item;
        const isProfessionalCourse = courseSource === 7 || courseSource === 8;
        return {
          title,
          wkId,
          fileType: 'xuanyes',
          coverUrl,
          studyHours,
          weikeType: courseSource === 5 ? 1 : 2,
          contentCompleteStandard: isProfessionalCourse ? 1 : 0, // 专业版微课默认按内容完成
          timeCompleteStandard: isProfessionalCourse ? 0 : 100,
          courseSource,
          courseFrom: 2 // 微课来源
        };
      });
      this.resolve(data);
      this.visible = false;
    }
  }
};
</script>